import DebtForm from '../../components/DebtForm/DebtForm'
import { useEffect } from 'react'
const AddDebt = () => {
    useEffect(() => {
        document.title =
            'Προσθήκη Οφειλής - Πλατφόρμα Ηλ. Πληρωμών Δήμου Βύρωνα'
    }, [])
    return (
        <>
            <div className="flex flex-col md:justify-center items-center grow">
                <DebtForm />
            </div>
        </>
    )
}
export default AddDebt
